import { atom } from 'jotai';
import { firstDateForAge, lastDateForAge } from '@/utils/date';
import { filtersAtom } from '../filter';

export const minAgeBirthDateToQueryAtom = atom(get => {
  const minAgeSelected = get(filtersAtom).minAge;
  return firstDateForAge(minAgeSelected);
});

export const maxAgeBirthDateToQueryAtom = atom(get => {
  const maxAgeSelected = get(filtersAtom).maxAge;
  return lastDateForAge(maxAgeSelected);
});
